/* eslint-disable filename-rules/match */

import { storeApi, useAppSelector } from "store/index";
import { selectAvailableHomeRoles, selectCurrentUserId } from "store/selectors";
import { usePromiseEffect } from "store/store-hooks";
import { useLocation } from "utils/routing";
import { HomeRole, homeUrlForRole } from "utils/urls";

export const getDefaultHomeRole = (availableRoles: HomeRole[]) => {
  for (const role of [HomeRole.ADMIN, HomeRole.INSTRUCTOR, HomeRole.SECTION_ASSISTANT]) {
    if (availableRoles.includes(role)) return role;
  }

  return HomeRole.STUDENT;
};

export const useHomeRole = () => {
  const location = useLocation();
  const userId = useAppSelector(selectCurrentUserId);

  // We need to load section and org users to determine roles
  // Skip API calls if userId is undefined (user not logged in)
  const { isLoading } = usePromiseEffect(() => {
    if (!userId) return Promise.resolve(undefined);

    return Promise.all([
      storeApi.section_users.list({ user_id: userId }),
      storeApi.org_users.list({ user_id: userId }),
      storeApi.course_users.list({ user_id: userId }),
      storeApi.course_grouping_users.list({ user_id: userId }),
    ]);
  }, [userId]);

  const availableRoles = useAppSelector(selectAvailableHomeRoles);

  const currentRole =
    availableRoles.find((role) => location.pathname.startsWith(homeUrlForRole(role))) ||
    HomeRole.STUDENT;

  return { currentRole, availableRoles, isLoading };
};
